import { Paper, Box, Typography, useTheme, Avatar, Button, CircularProgress, Divider, IconButton } from "@mui/material";
import { tokens } from "../../theme";
import InforCardSeller from "./info-card";
import { formatCPF, formatPhoneNumber, convertTimeStamp, formatBrDate } from "../../utils/formats";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import { useState, useEffect } from "react";
import { TextareaAutosize } from '@mui/material';

import { djangoApi } from "../../utils/axios/axios.utils";
import { useDispatch } from "react-redux";
import { setSellersUpdated } from "../../store/sellers/sellers.action";

import { storage } from "../../utils/firebase/firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import UploadIcon from "@mui/icons-material/Upload";
import imageCompression from "browser-image-compression";



const InforSectionSeller = ({ seller, isOpen }) => {
    console.log('seller here: ', seller)
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();

    const [sinceWhenData, setSinceWhenData] = useState(null);

    const [updateAnota, setupdateAnota] = useState(true);
    const [updateObs, setupdateObs] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [avatarUrl, setAvatarUrl] = useState(null);
    const [uploading, setUploading] = useState(false);


    const defaultImg = "../../../assets/img/user.jpeg"
    const sellerId = seller?.id;



    const [values, setValues] = useState({
        obs_to_display: "",
        ano_to_display: "",
    });
    useEffect(() => {
        setValues({
            obs_to_display: seller?.obs_to_display,
            ano_to_display: seller?.ano_to_display,
        })
    }, [seller]);
    // Generic handler for textareas
    const handleChange = (field) => (event) => {
        setValues((prevValues) => ({
            ...prevValues,
            [field]: event.target.value,
        }));
    };



    const hanlerOpenWhatsapp = (phoneNumber) => {
        const whatsappUrl = `https://wa.me/${phoneNumber}`;
        window.open(whatsappUrl)
    }

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const url = await getDownloadURL(ref(storage, `users_profile/${sellerId}.jpg`));
                setAvatarUrl(url);
            } catch {
                setAvatarUrl(null); // Fallback to default
            }
        };

        if (sellerId) fetchImage();
    }, [sellerId]);


    const handleUpload = async (event) => {
        const file = event.target.files[0];
        if (!file || !sellerId) return;

        setUploading(true);
        try {
            // Compress image
            const options = {
                maxSizeMB: 0.2, // 200KB
                maxWidthOrHeight: 500,
                useWebWorker: true,
            };
            const compressedFile = await imageCompression(file, options);

            const storageRef = ref(storage, `users_profile/${sellerId}.jpg`);
            await uploadBytes(storageRef, compressedFile);

            const newUrl = await getDownloadURL(storageRef);
            setAvatarUrl(newUrl);
        } catch (error) {
            console.error("Erro ao fazer upload:", error);
        } finally {
            setUploading(false);
        }
    };


    useEffect(() => {
        const getSinceWhen = (seller) => {
            if (seller?.firebase_user_created_timestamp) {
                return convertTimeStamp(seller?.firebase_user_created_timestamp)
            }
            if (seller.criados) {
                return formatBrDate(seller.criados.split('T')[0])
            }
            return " - "
        }
        const newDateHere = getSinceWhen(seller)
        setSinceWhenData(newDateHere)
    }, []);

    const handleUpdateInformation = async () => {
        setIsLoading(true)
        const params = JSON.stringify(values)
        try {
            await djangoApi
                .post(`sellers/sellers/${seller.id}/update_user_field/`, params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log(res)
                    const { status } = res
                    const { data } = res.data;
                    if (status === 201) {
                        dispatch(setSellersUpdated(data))
                        // console.log('status ', status)
                        // console.log('sellers: ', data)
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
        setupdateAnota(true)
        setupdateObs(true)
    }
    // console.log('seller here: ', seller)
    function formatEnderecoEntrega(obj) {
        const {
            end_logradouro_entrega,
            end_numero_entrega,
            end_complemento_entrega,
            end_bairro_entrega,
            end_cep_entrega,
            end_municipio_entrega,
        } = obj;

        const parts = [];

        if (end_logradouro_entrega) parts.push(end_logradouro_entrega.trim());
        if (end_numero_entrega) parts.push(`nº ${end_numero_entrega.trim()}`);
        if (end_complemento_entrega) parts.push(end_complemento_entrega.trim());
        if (end_bairro_entrega) parts.push(end_bairro_entrega.trim());
        if (end_municipio_entrega) parts.push(end_municipio_entrega.trim());
        if (end_cep_entrega) parts.push(`CEP ${end_cep_entrega.trim()}`);

        return parts.join(', ');
    }
    return (
        <Box sx={{ flexGrow: 1, height: '100vh' }}>
            <Box
                display="flex"
                flexDirection="row"
                gap="20px"
                justifyContent={"flex-start"}
                alignItems={"center"}
                borderBottom={'1px solid grey'}
                paddingBottom={"20px"}
                paddingLeft={isOpen ? "10px" : '-10px'}
                margin={isOpen ? "0px 10px" : '0px 5px'}
            // overflow={"auto"}
            >
                <Box pt={isOpen ? 2: 3} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box position="relative" width={90} height={120}>
                        <Avatar
                            variant="rounded"
                            src={!uploading ? (avatarUrl || defaultImg) : undefined}
                            sx={{
                                width: 90,
                                height: 120,
                                borderRadius: 2,
                                backgroundColor: uploading ? "#f0f0f0" : (!seller?.firebase_disabled ? "#4caf50" : "#e91e63"),
                                boxShadow: uploading
                                    ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                                    : "0px 4px 12px rgba(0, 0, 0, 0.25)",
                                objectFit: "cover",
                                transition: "box-shadow 0.3s ease",
                                "&:hover": {
                                    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.35)",
                                },
                            }}
                        >
                            {uploading && <CircularProgress size={28} />}
                        </Avatar>

                        <IconButton
                            component="label"
                            size="small"
                            sx={{
                                position: "absolute",
                                bottom:3,
                                right: 3,
                                backgroundColor: "grey",
                                backdropFilter: "blur(4px)",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                width: 22,
                                height: 20,
                                zIndex: 2,
                                "&:hover": {
                                    backgroundColor: "rgba(255,255,255,1)",
                                },
                            }}
                            disabled={uploading}
                        >
                            <UploadIcon fontSize="small" color=""/>
                            <input type="file" accept="image/*" hidden onChange={handleUpload} />
                        </IconButton>
                    </Box>
                    {
                        isOpen &&

                        <Box pt={4}>
                            <Typography variant="h5" color={'whitesmoke'}>
                                {seller?.nome}
                            </Typography>
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                alignItems={"center"}
                                justifyContent={"flex-start"}
                                gap={"5px"}
                                sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                                onClick={() => hanlerOpenWhatsapp(seller.telefone)}
                            >
                                <FontAwesomeIcon
                                    color={colors.greenAccent[400]}
                                    icon={faWhatsapp}
                                    size="1x"
                                    style={{
                                        filter: "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))"
                                    }}
                                />
                                <Typography variant="h6" color={colors.primary[100]} sx={{ paddingTop: '0px' }} fontWeight={"bold"}>
                                    {formatPhoneNumber(seller?.telefone)}
                                </Typography>
                            </Box>

                        </Box>
                    }
                </Box>


            </Box>
            {
                isOpen &&

                <Box
                    sx={{
                        // height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'auto',
                        paddingBottom: '100px'
                    }}
                >
                    <InforCardSeller editable={false} title="E-mail" value={seller?.email} />
                    <InforCardSeller editable={false} title="Data Nascimento" value={formatBrDate(seller?.data_nascimento)} />
                    <InforCardSeller editable={false} title="CPF" value={formatCPF(seller?.cpf)} />
                    <InforCardSeller editable={false} title="Usuário desde" value={sinceWhenData} />
                    <InforCardSeller editable={false} title="Endereço de Troca" value={formatEnderecoEntrega(seller)} valueCopy={true} />

                    <Box sx={{
                        display: 'flex', flexDirection: 'column', gap: '10px',
                    }}
                        borderTop={'1px solid grey'}
                        margin={"60px 3px 0px 3px"}
                    >
                        {
                            updateObs ?


                                <InforCardSeller
                                    title="Observações Vendedora:"
                                    handleUpdate={setupdateObs}
                                    valueUpdate={updateObs}
                                    value={values.obs_to_display}
                                    editable={true}
                                    paddingHere="10px"
                                />
                                :

                                <Box
                                    sx={{
                                        width: '80%',
                                        marginLeft: '30px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end',
                                        alignItems: 'end',
                                        gap: '10px',
                                    }}
                                >
                                    <TextareaAutosize
                                        placeholder="Escreva aqui as observações..."
                                        minRows={15}
                                        value={values.obs_to_display}
                                        onChange={handleChange("obs_to_display")}
                                        style={{
                                            width: '100%', // Stretch textarea to full width
                                            padding: '8px',
                                            fontSize: '0.6rem',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            marginTop: '8px', // Add spacing from the bottom box
                                            minWidth: "200px", // Set min-width and max-width to the same value
                                            maxWidth: "200px",
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleUpdateInformation}
                                        disabled={isLoading} // Disable the button while loading
                                        startIcon={isLoading ? <CircularProgress size={24} color="inherit" /> : null}
                                    >
                                        {isLoading ? "Salvando..." : "Salvar"}
                                    </Button>
                                </Box>

                        }
                        {
                            updateAnota ?
                                <InforCardSeller
                                    title="Anotações Vendedora:"
                                    value={values.ano_to_display}
                                    editable={true}
                                    handleUpdate={setupdateAnota}
                                    valueUpdate={updateAnota}
                                    paddingHere="10px"
                                />
                                :
                                <Box
                                    sx={{
                                        width: '80%',
                                        marginLeft: '30px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end',
                                        alignItems: 'end',
                                        gap: '10px'
                                    }}
                                >
                                    <TextareaAutosize
                                        placeholder="Escreva aqui as anotações..."
                                        minRows={15}
                                        value={values.ano_to_display}
                                        onChange={handleChange("ano_to_display")}
                                        style={{
                                            width: '100%', // Stretch textarea to full width
                                            padding: '8px',
                                            fontSize: '0.6rem',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            marginTop: '8px', // Add spacing from the bottom box
                                            minWidth: "200px", // Set min-width and max-width to the same value
                                            maxWidth: "200px",
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleUpdateInformation}
                                        disabled={isLoading} // Disable the button while loading
                                        startIcon={isLoading ? <CircularProgress size={24} color="inherit" /> : null}
                                    >
                                        {isLoading ? "Salvando..." : "Salvar"}
                                    </Button>
                                </Box>
                        }
                    </Box>


                </Box>
            }

        </Box>
    );
}

export default InforSectionSeller;